/**
 * @generated SignedSource<<bad60ff41b0654a664fd82e02d4fc35b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsPostiesArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "helpersCheckIsPostiesArticle";
};
export type helpersCheckIsPostiesArticle$key = {
  readonly " $data"?: helpersCheckIsPostiesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPostiesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsPostiesArticle"
};

(node as any).hash = "18e1e6159187c7d2a1d2181fb8a945c6";

export default node;
